import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import filters from "@/plugins/filters";
import '@/styles/reset.css'

Vue.config.productionTip = false
Vue.use(filters);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
